<template>
	<i v-if="italic">{{ text }}</i>
	<p v-else> {{ text }}</p>
</template>

<script lang="ts">
	import {Vue, Component, Prop} from 'vue-property-decorator';

	@Component({})
	export default class AsiLabel extends Vue {
		@Prop({required: true})
		public text!: string | null;

		@Prop({type: Boolean, default: false})
		public italic!: boolean;

	}
</script>

<style scoped lang="scss">

</style>
